import { track, SUBMIT } from '@updater-core/lib/tracker';
import { ENVIRONMENT, IS_STAGING, IS_PRODUCTION } from '../../environment';
import { graphql } from '../../helpers';
import gql from 'graphql-tag';
import { getVariation } from '@updater-core/lib/optimizely';

const MOVER_PASS_OPT_IN = 'UPD_mover_pass_opt_in';
const HOME_ADVISOR = 'UPD_mover_pass_opt_in_home_advisor';
const CLAIM_PROMOTIONS_AT_SIGN_UP = 'UPD_claim_promotions_at_sign_up';
export const EO_FIREHOSE_TEST = 'FireHose_Existing_EO_Page';
export const NOTIFY_CLAIM =
  'UPD_CLAIMED_PROMOTION_AT_SIGN_UP_SHOW_NOTIFICATION';
function handleLocalStorage() {
  const shouldClaimMoverPass =
    localStorage.getItem(MOVER_PASS_OPT_IN) === 'true';
  const shouldClaimHomeAdvisor = localStorage.getItem(HOME_ADVISOR) === 'true';
  const generic = JSON.parse(localStorage.getItem(CLAIM_PROMOTIONS_AT_SIGN_UP));
  localStorage.removeItem(MOVER_PASS_OPT_IN);
  localStorage.removeItem(HOME_ADVISOR);
  localStorage.removeItem(CLAIM_PROMOTIONS_AT_SIGN_UP);
  return {
    generic,
    shouldClaimHomeAdvisor,
    shouldClaimMoverPass,
  };
}
const MOVER_PASS_ID = {
  dev: 6,
  staging: 23,
  prod: 18,
};
const HOME_ADVISOR_ID = {
  dev: 7,
  staging: 30,
  prod: 24,
};
const source = 'moverpass';

function claimPromotion(headers, id) {
  return graphql.fetchGraphQLQuery({
    headers,
    query: gql`
      mutation claimMoverPass($input: ClaimPromotionInput) {
        claimPromotion(input: $input) {
          claimedPromotion {
            id
          }
        }
      }
    `,
    variables: {
      input: {
        promotionId: id,
        source,
      },
    },
    url: `${ENVIRONMENT.endpoints.api.url}/graphql`,
  });
}

function claimHomeAdvisor(headers) {
  let id = HOME_ADVISOR_ID.dev;
  if (IS_PRODUCTION) {
    id = HOME_ADVISOR_ID.prod;
  } else if (IS_STAGING || ENVIRONMENT.endpoints.api.url.includes('staging')) {
    id = HOME_ADVISOR_ID.staging;
  }
  const homeAdvisorDetails = {
    promotionId: id,
    contactPreference: true,
  };
  track({
    verb: SUBMIT,
    object: 'Home Advisor At Sign Up',
    details: {
      ...homeAdvisorDetails,
    },
  });
  track({
    verb: SUBMIT,
    object: 'Unlock Deal',
    details: {
      ...homeAdvisorDetails,
    },
  });

  return claimPromotion(headers, id);
}

function claimMoverPass(headers) {
  let id = MOVER_PASS_ID.dev;
  if (IS_PRODUCTION) {
    id = MOVER_PASS_ID.prod;
  } else if (IS_STAGING || ENVIRONMENT.endpoints.api.url.includes('staging')) {
    id = MOVER_PASS_ID.staging;
  }

  const moverPassDetails = {
    promotionId: id,
    contactPreference: true,
  };

  track({
    verb: SUBMIT,
    object: 'Unlock Deal',
    details: {
      ...moverPassDetails,
    },
  });

  track({
    verb: SUBMIT,
    object: 'Mover Pass At Sign Up',
    details: {
      ...moverPassDetails,
    },
  });

  return claimPromotion(headers, id);
}

function claimGeneric(headers, { promotions }) {
  return promotions.map(({ id, promotionName = '', contactPreference }) => {
    track({
      verb: SUBMIT,
      object: `${promotionName} At Sign Up`,
      details: {
        promotionId: id,
        contactPreference,
      },
    });

    track({
      verb: SUBMIT,
      object: 'Unlock Deal',
      details: {
        promotionId: id,
        contactPreference,
      },
    });

    if (promotionName.toLowerCase().includes('bbby')) {
      track({
        verb: SUBMIT,
        domain: 'promotions',
        object: 'unlock_bbby',
        details: {
          promotionId: id,
          contactPreference,
        },
      });
    }

    return claimPromotion(headers, id);
  });
}

function addNotification() {
  getVariation(
    EO_FIREHOSE_TEST,
    {},
    false // don't activate here just check
  )
    .then((v) =>
      !v
        ? getVariation('Notify_Users_About_MoverPass_Claim')
        : Promise.resolve(v)
    )
    .then((v) => v === 'notify' && localStorage.setItem(NOTIFY_CLAIM, true));
}

export function handlePromotionClaimsAtSignUp(responseHeaders) {
  const {
    shouldClaimMoverPass,
    shouldClaimHomeAdvisor,
    generic,
  } = handleLocalStorage();

  if (shouldClaimHomeAdvisor || shouldClaimMoverPass || generic) {
    addNotification();
  }

  const claimMoverPassPromise = shouldClaimMoverPass
    ? claimMoverPass(responseHeaders)
    : Promise.resolve();
  const claimHomeAdvisorPromise = shouldClaimHomeAdvisor
    ? claimHomeAdvisor(responseHeaders)
    : Promise.resolve();
  const claimGenericPromise = generic
    ? claimGeneric(responseHeaders, generic)
    : Promise.resolve();

  return Promise.all([
    claimHomeAdvisorPromise,
    claimMoverPassPromise,
    claimGenericPromise,
  ]);
}
